import {FieldArray} from 'redux-form'
import ModifierOptionsFieldArray from './ModifierOptionsFieldArray'

class ModifierOptions extends React.Component {
  render () {
    return <FieldArray
      name='options'
      component={ModifierOptionsFieldArray}
    />
  }
}

export default ModifierOptions



// WEBPACK FOOTER //
// ./app/pages/Library/Modifier/Detail/ModifierForm/ModifierOptions/ModifierOptions.js